import { useMutation, useQueryClient } from '@tanstack/react-query';
import { budgetService } from '@services/budget';
import { toast } from 'react-toastify';
import { PENDING_BUDGET_REQUESTS_QUERY_KEY } from './usePendingBudgetRequests';
import { BUDGET_PROPOSAL_CONVERSATION_QUERY_KEY } from './useBudgetProposalConversation';
import { BUDGET_REQUEST_DETAILS_QUERY_KEY } from './useBudgetRequestDetails';
import { PAGINATED_BUDGET_REQUESTS_QUERY_KEY } from './usePaginatedBudgetRequests';
import { useTranslation } from '@hooks/useTranslation';

export const useRejectBudgetProposal = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (proposalId: string) => budgetService.rejectBudgetProposal(proposalId),
    onSuccess: () => {
      toast.success(tActionMessages.budgetProposalRejected);
      queryClient.invalidateQueries({ queryKey: [PAGINATED_BUDGET_REQUESTS_QUERY_KEY], refetchType: 'active' });
      queryClient.invalidateQueries({ queryKey: [PENDING_BUDGET_REQUESTS_QUERY_KEY], refetchType: 'active' });
      queryClient.invalidateQueries({ queryKey: [BUDGET_PROPOSAL_CONVERSATION_QUERY_KEY], refetchType: 'active' });
      queryClient.invalidateQueries({ queryKey: [BUDGET_REQUEST_DETAILS_QUERY_KEY], refetchType: 'active' });
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.errors?.[0]?.message || error?.message || tActionMessages.requestError,
      );
    },
  });
};